module.exports = __webpack_public_path__ + "img/hourglass_3_fill.5a0fcb4c.svg";